import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PhoneFrame } from './components/layout/PhoneFrame';
import { MainLayout } from './components/layout/MainLayout';
import { Splash } from './pages/Splash';
import { Welcome } from './pages/Welcome';
import { Onboarding } from './pages/Onboarding';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { OTP } from './pages/auth/OTP';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { ResetPassword } from './pages/auth/ResetPassword';
import { RoleSelect } from './pages/auth/RoleSelect';
import { Feed } from './pages/Feed';
import { Discover } from './pages/Discover';
import { Search } from './pages/Search';
import { SearchResults } from './pages/SearchResults';
import { UploadOptions } from './pages/upload/UploadOptions';
import { Record } from './pages/upload/Record';
import { Preview } from './pages/upload/Preview';
import { Caption } from './pages/upload/Caption';
import { Progress } from './pages/upload/Progress';
import { Success } from './pages/upload/Success';
import { Profile } from './pages/Profile';
import { EditProfile } from './pages/EditProfile';
import { Notifications } from './pages/Notifications';
import { Settings } from './pages/Settings';
import { SettingsPrivacy } from './pages/settings/Privacy';
import { SettingsNotifications } from './pages/settings/NotificationSettings';
import { SettingsSecurity } from './pages/settings/Security';
import { HashtagFeed } from './pages/HashtagFeed';
import { ThemeProvider } from './context/ThemeContext';
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="flex w-full h-full items-center justify-center text-softGray" data-id="element-0">
    {title}
  </div>;
export function App() {
  return <ThemeProvider data-id="element-1">
      <BrowserRouter data-id="element-2">
        <PhoneFrame data-id="element-3">
          <Routes data-id="element-4">
            {/* Entry Flow */}
            <Route path="/" element={<Splash data-id="element-6" />} data-id="element-5" />
            <Route path="/welcome" element={<Welcome data-id="element-8" />} data-id="element-7" />
            <Route path="/onboarding" element={<Onboarding data-id="element-10" />} data-id="element-9" />

            {/* Auth Flow */}
            <Route path="/auth/login" element={<Login data-id="element-12" />} data-id="element-11" />
            <Route path="/auth/register" element={<Register data-id="element-14" />} data-id="element-13" />
            <Route path="/auth/role" element={<RoleSelect data-id="element-16" />} data-id="element-15" />
            <Route path="/auth/otp" element={<OTP data-id="element-18" />} data-id="element-17" />
            <Route path="/auth/forgot" element={<ForgotPassword data-id="element-20" />} data-id="element-19" />
            <Route path="/auth/reset" element={<ResetPassword data-id="element-22" />} data-id="element-21" />

            {/* Main App with Bottom Nav */}
            <Route element={<MainLayout data-id="element-24" />} data-id="element-23">
              <Route path="/feed" element={<Feed data-id="element-26" />} data-id="element-25" />
              <Route path="/discover" element={<Discover data-id="element-28" />} data-id="element-27" />
              <Route path="/notifications" element={<Notifications data-id="element-30" />} data-id="element-29" />
              <Route path="/profile" element={<Profile data-id="element-32" />} data-id="element-31" />
            </Route>

            {/* Modals / Full Screen without Bottom Nav */}
            <Route path="/upload" element={<UploadOptions data-id="element-34" />} data-id="element-33" />
            <Route path="/upload/record" element={<Record data-id="element-36" />} data-id="element-35" />
            <Route path="/upload/preview" element={<Preview data-id="element-38" />} data-id="element-37" />
            <Route path="/upload/caption" element={<Caption data-id="element-40" />} data-id="element-39" />
            <Route path="/upload/progress" element={<Progress data-id="element-42" />} data-id="element-41" />
            <Route path="/upload/success" element={<Success data-id="element-44" />} data-id="element-43" />

            <Route path="/search" element={<Search data-id="element-46" />} data-id="element-45" />
            <Route path="/search/results" element={<SearchResults data-id="element-48" />} data-id="element-47" />

            <Route path="/profile/edit" element={<EditProfile data-id="element-50" />} data-id="element-49" />
            <Route path="/settings" element={<Settings data-id="element-52" />} data-id="element-51" />
            <Route path="/settings/privacy" element={<SettingsPrivacy data-id="element-54" />} data-id="element-53" />
            <Route path="/settings/notifications" element={<SettingsNotifications data-id="element-56" />} data-id="element-55" />
            <Route path="/settings/security" element={<SettingsSecurity data-id="element-58" />} data-id="element-57" />
            <Route path="/hashtag/:tag" element={<HashtagFeed data-id="element-60" />} data-id="element-59" />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-62" />} data-id="element-61" />
          </Routes>
        </PhoneFrame>
      </BrowserRouter>
    </ThemeProvider>;
}